module.exports = __webpack_public_path__ + "static/img/iplus1_understand.654f9ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/iplus1_understand.jpg
// module id = yX3v
// module chunks = 1